import storeModule from '../store-module'
import { defineStore } from 'pinia'

export default defineStore('activities-notes', storeModule.createStoreModule('activities-notes'))
